import React, {useMemo} from "react";
import {Section} from "../Section";
import {IOSSwitch} from "../IOSSwitch";
import {Typography} from "../../../../designSystem/components/Typography";
import {ActionButton} from "../../../../designSystem/components/ActionButton";

export const RuleList = ({ rules, selectedId, onSelect, onToggle }) => {
  const sortedRules = useMemo(() => {
    return rules
      .sort((a, b) => {
        const aTime = a.createdAt?._seconds ?? a.createdAt?.seconds ?? a.createdAt?.toDate?.().getTime() / 1000 ?? 0;
        const bTime = b.createdAt?._seconds ?? b.createdAt?.seconds ?? b.createdAt?.toDate?.().getTime() / 1000 ?? 0;
        return bTime - aTime; // Descending
      })
  }, [rules])

  return (
    <Section
      title="規則清單"
      right={
        <Typography variant="caption">
          共 {rules.length} 條
        </Typography>
      }
    >
      <div className="bg-white">
        {sortedRules.map((rule, index) => (
          <div
            key={rule.id}
            className={`
            border-l border-t border-r p-3 flex items-center justify-between
            ${selectedId === rule.id ? "border border-emerald-400 bg-emerald-50" : ""}
            ${index === 0 ? 'rounded-t-lg' : ''}
            ${index === sortedRules.length - 1 ? 'rounded-b-lg border-b' : ''}
          `}
          >
            <div className="flex items-center gap-4">
              <IOSSwitch
                checked={!!rule.enabled}
                onChange={() => onToggle(rule.id)}
                inputProps={{"aria-label": `toggle ${rule.name}`}}
              />
              <div className="text-left">
                <Typography variant="bodyBold">
                  {rule?.match?.keywords?.join(', ')}
                </Typography>
              </div>
            </div>

            <div className="flex items-center gap-4">
              <div className="w-[50px]">
                <Typography variant="caption">
                  優先度 {rule.priority}
                </Typography>
              </div>
              <ActionButton
                onClick={() => onSelect(rule.id)}
                iconName="fa-pencil"
              />
            </div>
          </div>
        ))}
      </div>
    </Section>
  )
}
